import React from 'react';
import { motion } from 'framer-motion';

interface EmptyStateProps {
    type?: 'no-results' | 'all-resolved' | 'no-filter';
    onClearFilters?: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
    type = 'no-results',
    onClearFilters
}) => {
    const configs = {
        'no-results': {
            icon: (
                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <circle cx="11" cy="11" r="8"/>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                    <line x1="8" y1="11" x2="14" y2="11"/>
                </svg>
            ),
            title: 'Ничего не найдено',
            description: 'Попробуйте изменить фильтры или поисковый запрос'
        },
        'all-resolved': {
            icon: (
                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                    <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
            ),
            title: 'Все инциденты устранены',
            description: 'Отличная работа! На данный момент нет активных проблем'
        },
        'no-filter': {
            icon: (
                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="8" y1="12" x2="16" y2="12"/>
                </svg>
            ),
            title: 'Нет инцидентов',
            description: 'В этой категории пока нет записей'
        }
    };

    const config = configs[type];

    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className="flex flex-col items-center justify-center py-16 text-center"
        >
            <div className="w-16 h-16 rounded-2xl bg-[var(--bg)] border border-[var(--border)] flex items-center justify-center text-[var(--text-muted)] mb-4">
                {config.icon}
            </div>
            <h3 className="text-[16px] font-semibold text-[var(--text)] mb-2">
                {config.title}
            </h3>
            <p className="text-[13px] text-[var(--text-secondary)] max-w-[280px] mb-4">
                {config.description}
            </p>
            {onClearFilters && (
                <button
                    onClick={onClearFilters}
                    className="px-4 py-2 rounded-lg bg-[var(--brand)] text-white text-[13px] font-medium hover:opacity-90 transition-opacity"
                >
                    Сбросить фильтры
                </button>
            )}
        </motion.div>
    );
};